export const environment = {
  production: false,
  prePrd: false,
  develop: true,
  homolog: false,
  equa: false,
  showInProduction: true,
  showDue: true,
  showcaseApi: 'https://api.dev.ellos.org.br/ellos/showcase/api',
  meetingApi: 'https://api.dev.ellos.org.br/ellos/matchmaking/api',

  payment: 'https://api.dev.ellos.org.br/ellos/payment/api',
  ncmApi: 'https://api.dev.ellos.org.br/ellos/ncm/api',

  associateApi: 'https://api.dev.ellos.org.br/ellos/associate/api',
  companyApi: 'https://api.dev.ellos.org.br/ellos/company/api',
  profileApi: 'https://api.dev.ellos.org.br/ellos/profile/api',

  easyTradeApi: 'https://api.dev.ellos.org.br/ellos/easytrade/api',
  pricing: 'https://api.dev.ellos.org.br/ellos/easytrade/api',

  exportationApi: 'https://api.dev.ellos.org.br/ellos/easytrade-exportation/api',

  easytradeCustomsApi: 'https://api.dev.ellos.org.br/ellos/easytrade-customs/api',

  easyTradeCertifierApi: 'https://api.dev.ellos.org.br/ellos/easytrade-certifiers/api',

  originCertificate: 'ADICIONAR-API QUANDO EXISTIR',
  reCaptchaSiteKey: '6LdDTKsfAAAAAMrOYAJkrP14nkdia0737kTtuvEw'
};
